import { useCartStore } from "../../store/cartStore";

export const useCartItem = (productId) => {
  return useCartStore((state) => {
    const cart = state.cart;

    if (!cart?.items) return null;

    return (
      cart.items.find(
        (item) =>
          item.product?.id === productId ||
          item.product_id === productId
      ) || null
    );
  });
};
